"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTargetPageRowCount = exports.getFirstChunkVariables = exports.getFirstChunkSize = exports.getShouldChunkRows = void 0;
const pagination_utils_1 = require("../../../../common/table-pagination/pagination.utils");
const getShouldChunkRows = (pageSize, chunkSize) => (!!chunkSize && chunkSize > 0 && pageSize > chunkSize);
exports.getShouldChunkRows = getShouldChunkRows;
const getFirstChunkSize = (pageSize, chunkSize) => ((0, exports.getShouldChunkRows)(pageSize, chunkSize) ? chunkSize : pageSize);
exports.getFirstChunkSize = getFirstChunkSize;
const getFirstChunkVariables = (variables, shouldChunkRows, firstChunkSize) => {
    if (!shouldChunkRows || !variables)
        return variables !== null && variables !== void 0 ? variables : {};
    if (variables.first && variables.first > firstChunkSize) {
        return Object.assign(Object.assign({}, variables), { first: firstChunkSize });
    }
    if (!variables.last || variables.last <= firstChunkSize || !variables.before) {
        return variables;
    }
    const beforeOffset = (0, pagination_utils_1.parseOffsetFromCursor)(variables.before);
    const startOffset = Math.max(beforeOffset - variables.last, 0);
    return Object.assign(Object.assign({}, variables), { after: startOffset === 0 ? null : (0, pagination_utils_1.createCustomOffsetCursor)(startOffset), before: null, first: firstChunkSize, last: null });
};
exports.getFirstChunkVariables = getFirstChunkVariables;
const getTargetPageRowCount = (pageSize, totalCount, pageInfo) => {
    const currentPageStartOffset = (0, pagination_utils_1.parseOffsetFromCursor)(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.startCursor);
    return Math.min(pageSize, Math.max(totalCount - currentPageStartOffset, 0));
};
exports.getTargetPageRowCount = getTargetPageRowCount;
